<template>
  <!-- Row Loop -->
  <b-row>
    <b-col v-if="IsReadOnly !== true"
      cols="12"
      class="d-flex justify-content-end mb-1"
    >
      <b-button
        variant="warning"
        @click="personalEditClicked(personal.id)"
      >
        แก้ไข
      </b-button>
      <b-button 
      class="ml-1"
      variant="danger"
      @click="personalDeleteClicked(personal.id)"
      >
        ลบ
      </b-button>
    </b-col>

    <b-col md="6">
      <b-form-group
        label-cols-md="6"
        label="เลขบัตรประชาชน/พาสปอร์ต:"
        label-for="identity"
      >
        <div class="col-form-label">
          {{ personal.identity }}
        </div>
      </b-form-group>
    </b-col>

    <b-col md="6">
      <b-form-group
        label-cols-md="6"
        label="ที่อยู่ปัจจุบันที่สามารถติดต่อได้"
        label-for="address"
      >
        <div class="col-form-label">
          {{ personal.address }}
        </div>
      </b-form-group>
    </b-col>

    <b-col md="6">
      <b-form-group
        label-cols-md="6"
        label="ชื่อ-นามสกุล ผู้ร้องทุกข์:"
        label-for="name"
      >
        <div class="col-form-label">
          {{ personal.title }} {{ personal.name }} {{ personal.lastname }}
        </div>
      </b-form-group>
    </b-col>

    <b-col md="6">
      <b-form-group
        label-cols-md="6"
        label="หมายเลขโทรศัพท์มือถือ:"
        label-for="mobile"
      >
        <div class="col-form-label">
          {{ personal.mobile }}
        </div>
      </b-form-group>
    </b-col>

    <b-col md="6">
      <b-form-group
        label-cols-md="6"
        label="วัน เดือน ปีเกิด:"
        label-for="dateOfBirth"
      >
        <div class="col-form-label">
          {{ personal.dateOfBirth }}
        </div>
      </b-form-group>
    </b-col>

    <b-col md="6">
      <b-form-group
        label-cols-md="6"
        label="LineID:"
        label-for="lineId"
      >
        <div class="col-form-label">
          {{ personal.line }}
        </div>
      </b-form-group>
    </b-col>

    <b-col md="6">
      <b-form-group
        label-cols-md="6"
        label="อายุ:"
        label-for="age"
      >
        <div class="col-form-label">
          {{ personal.age }}
        </div>
      </b-form-group>
    </b-col>

    <b-col md="6">
      <b-form-group
        label-cols-md="6"
        label="อีเมล:"
        label-for="email"
      >
        <div class="col-form-label">
          {{ personal.email }}
        </div>
      </b-form-group>
    </b-col>
    <b-col cols="12">
      <hr>
    </b-col>
  </b-row>
</template>

<script>
import {
  BRow,
  BCol,
  BFormGroup,
  BFormInput,
  // BFormInvalidFeedback,
  BForm,
  BButton,

} from 'bootstrap-vue'
// import { required, email } from '@validations'

export default {
  components: {
    // ValidationProvider,
    // ValidationObserver,
    // FormWizard,
    // TabContent,
    BRow,
    BCol,
    BFormGroup,
    BFormInput,
    // vSelect,
    // BFormInvalidFeedback,
    // eslint-disable-next-line vue/no-unused-components
    // ToastificationContent,
    BForm,
    BButton,
  },
  props: {
    IsReadOnly: Boolean,
    personal: {
      type: Object,
      // Object or array defaults must be returned from
      // a factory function
      default() {
        return {
          id: {
            type: Number,
            default: 0,
          },
          identity: {
            type: String,
            default: '0000000000000',
          },
          title: {
            type: String,
            default: 'title',
          },
          name: {
            type: String,
            default: 'name',
          },
          lastname: {
            type: String,
            default: 'lastname',
          },
          sex: {
            type: String,
            default: 'sex',
          },
          dateofbirth: {
            type: String,
            default: 'dateofbirth',
          },
          address: {
            type: String,
            default: 'address',
          },
          tumbon: {
            type: String,
            default: 'tumbon',
          },
          ampher: {
            type: String,
            default: 'ampher',
          },
          province: {
            type: String,
            default: 'province',
          },
          zipcode: {
            type: String,
            default: 'zipcode',
          },
          tel: {
            type: String,
            default: 'tel',
          },
          mobile: {
            type: String,
            default: 'mobile',
          },
          email: {
            type: String,
            default: 'email',
          },
          line: {
            type: String,
            default: 'line',
          },
        }
      },

    },
  },
  methods: {
    personalEditClicked(id) {
      console.log('personalEditClicked')
      this.$emit('personal-edit-clicked', id)
    },
    personalDeleteClicked(id) {
      this.$emit('personal-delete-clicked', id)
    }
  },
}

</script>
